import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getNonBilledSessionsReport(params: any): AxiosPromise {
    return EndPointService.get('/seances/report/non-billed', { params });
}

export default {
    getNonBilledSessionsReport,
};
